import type {Component} from 'grapesjs';
import {POSTERMYWALL_FORM_BACKGROUND_TYPE} from '@FormMakerReact/components/postermywall-form-background/postermywall-form-background';
import {POSTERMYWALL_CONFIRMATION_FORM_TYPE} from '@FormMakerReact/components/postermywall-confirmation-form/postermywall-confirmation-form';
import {registerRightPanelSector} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';
import {ConfirmationAlignmentControl} from './components/confirmation-alignment-control/confirmation-alignment-control';
import {FormBackgroundBgColorControl} from './components/form-background-bg-color-control/form-background-bg-color-control';
import {FormBackgroundFieldToggleListControl} from './components/form-background-field-toggle-list-control/form-background-field-toggle-list-control';
import {FormBackgroundFontControl} from './components/form-background-font-control/form-background-font-control';
import {FormBackgroundNotificationToggleControl} from './components/form-background-notification-toggle-control/form-background-notification-toggle-control';
import {FormBackgroundDescriptionToggleControl} from './components/form-background-description-toggle-control/form-background-description-toggle-control';

function resolveFormBackgroundTitle(component: Component): string {
  if (component.parent()?.get('type') === POSTERMYWALL_CONFIRMATION_FORM_TYPE) {
    return window.i18next.t('pmwjs_form_maker_confirmation_form');
  }
  return window.i18next.t('pmwjs_signup_form');
}

registerRightPanelSector(POSTERMYWALL_FORM_BACKGROUND_TYPE, {
  title: resolveFormBackgroundTitle,
  controls: [
    FormBackgroundBgColorControl,
    FormBackgroundFontControl,
    ConfirmationAlignmentControl,
    FormBackgroundNotificationToggleControl,
    FormBackgroundDescriptionToggleControl,
    FormBackgroundFieldToggleListControl,
  ],
});
